import { securePostRequest } from '../utils/request';

export const pageRead = (body: { title: string; url: string; result: boolean }) => securePostRequest('api/v1/app/page-read')(body);
